export const DECRYPT_VAULT_FORM_ID = 'decrypt-vault-form';
export const EDIT_VAULT_FORM_ID = 'edit-vault-form';
export const AUDIT_TRAILS_ID = 'audit-trails';
